import img from "../../assets/images/dashboard.jpg";
import store from "../../assets/images/store.png";
import google from "../../assets/images/google.png";
export const Hero = () => {
  return (
    <section className="relative pt-40 pb-40 bg-primary/10" id="home">
      <div className="container">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-6 gap-y-10 items-center">
          <div className="relative">
            <h1 className="text-3xl md:text-5xl/tight lg:text-6xl/tight text-black tracking-normal capitalize leading-normal font-bold max-w-2xl mt-4">
              Who We Are <span className="text-primary">At Asureis, </span>
            </h1>
            <p className="text-base text-muted font-medium max-w-lg mt-6 capitalize">
              we are agents first. We understand the challenges of selling ACA
              health insurance because we've lived them. That’s why we built a
              CRM designed specifically for agents—by agents. Our platform is
              built to streamline workflows, eliminate inefficiencies, and
              provide every tool necessary for success in this competitive
              industry.
            </p>
            {/*
           <div className="flex flex-wrap items-center justify-center lg:justify-normal gap-3 mt-10">
              <img
                src={store}
                className="h-14"
                alt="apple"
                width={190}
                height={56}
              />
              <img
                src={google}
                className="h-14"
                alt="google"
                width={189}
                height={56}
              />
            </div>
            */}
          </div>
          <div className="relative">
            <img
              src={img}
              className="lg:ms-auto mx-auto rounded-xl"
              alt=""
              width={658}
              height={424}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
